var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Image as ChakraImage } from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from "react";
export const FocalImage = (props) => {
    const [backgroundPosition, setBackgroundPosition] = useState({ x: 0, y: 0 });
    const ref = useRef(null);
    /**
     * We need to download the image again to get its dimensions. Luckily, as
     * long as we use a regular JS Image object, most browsers will just reuse
     * their already loaded version, adding virtually no network overhead.
     */
    const getImageDimensions = (imageSrc) => {
        return new Promise((resolve, reject) => {
            const image = new Image();
            image.src = imageSrc;
            image.onload = () => {
                resolve({ width: image.width, height: image.height });
            };
        });
    };
    /**
     * Since we will always use CSS background-size cover, our image will always
     * be 100% in one dimension and be movable on the other. We determine which
     * axis to move by comparing aspect ratios of our element and the image.
     */
    const getMoveDirection = (imageWidth, imageHeight, containerWidth, containerHeight) => {
        let imageRatio = imageWidth / imageHeight;
        let elementRatio = containerWidth / containerHeight;
        if (imageRatio < elementRatio) {
            return "y";
        }
        return "x";
    };
    /**
     * This function will determine the pixel value of the necessary shift to get
     * our focal point in the center as best as we can. After calculating the shift
     * to get our focal point in total center, it also checks for bounds so the
     * image always covers the whole element.
     */
    const getShiftAlongAxis = (targetLength, imageLength, focalPoint) => {
        let maximumShift = imageLength - targetLength;
        let pointOfInterest = imageLength * focalPoint / 100;
        let shift = pointOfInterest - targetLength / 2;
        if (shift > maximumShift) {
            shift = maximumShift;
        }
        if (shift < 0) {
            shift = 0;
        }
        return -1 * shift;
    };
    const getElementDimensions = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!ref.current) {
            return { width: 100, height: 100 };
        }
        return { width: ref.current.getBoundingClientRect().width, height: ref.current.getBoundingClientRect().height };
    });
    const getBackgroundPosition = () => __awaiter(void 0, void 0, void 0, function* () {
        let x = 0, y = 0;
        if (!props.src) {
            return { x, y };
        }
        const elementDimensions = yield getElementDimensions();
        const imageDimensions = yield getImageDimensions(props.src);
        let direction = getMoveDirection(imageDimensions.width, imageDimensions.height, elementDimensions.width, elementDimensions.height);
        if (direction === "x") {
            let targetAxisLength = elementDimensions.width;
            let imageAxisLength = elementDimensions.height / imageDimensions.height * imageDimensions.width;
            y = 0;
            x = getShiftAlongAxis(targetAxisLength, imageAxisLength, props.focalPoint[0]);
            return { x, y };
        }
        let targetAxisLength = elementDimensions.height;
        let imageAxisLength = elementDimensions.width / imageDimensions.width * imageDimensions.height;
        x = 0;
        y = getShiftAlongAxis(targetAxisLength, imageAxisLength, props.focalPoint[1]);
        return { x, y };
    });
    useEffect(() => {
        const center = () => __awaiter(void 0, void 0, void 0, function* () {
            const position = yield getBackgroundPosition();
            setBackgroundPosition(position);
        });
        center();
    }, [props.src, props.focalPoint]);
    return React.createElement(ChakraImage, Object.assign({ ref: ref }, props, { objectFit: "cover", objectPosition: backgroundPosition.x + "px " + backgroundPosition.y + "px" }));
};
